import { render } from "./lei-search.vue?vue&type=template&id=524688f2&ts=true"
import script from "./lei-search.vue?vue&type=script&lang=ts"
export * from "./lei-search.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__